import { Auth } from "aws-amplify";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoaderButton from "../components/LoaderButton";
import photo1 from "../images/sofagirl.svg";
import FormImage from "../layouts/formimage";
import { Constants } from "../libs/Constants";
import { get } from "../libs/dbFunctions";
import { useFormFields } from "../libs/hooksLib";
import "./Login.css";

export default function Login(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState(null);

  const [fields, handleFieldChange] = useFormFields({
    email: "",
    password: "",
  });

  async function handleSubmit(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();

    setIsLoading(true);
    setErrors(null);

    try {
      let email = fields.email.toLowerCase();
      Auth.configure({ storage: sessionStorage });
      let auth = await Auth.signIn(email, fields.password);

      let o = await get(Constants.dbTypes.USER, auth.username);
      props.setUserObj(o);
      o = await get(Constants.dbTypes.COMPANY, o.companyId);
      props.setActiveCompany(o);
      props.userHasAuthenticated(true);
    } catch (e) {
      if (e.code === "PasswordResetRequiredException") {
        setErrors("Invalid user");
      } else if (e.code === "UserNotConfirmedException") {
        setErrors("You have not confirmed your email. Please sign up again.");
      } else {
        setErrors(e.message);
      }
      setIsLoading(false);
    }
  }

  return (
    <FormImage
      title="Making ESPPs Simple"
      subtitle="Taabl gives you all the benefits of your ESPP without the payroll
    deduction."
      image={photo1}
      bgClass="background-green"
    >
      <h2 className="text-center pb-3">Log in to Taabl</h2>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="w-100"
      >
        <Form.Group controlId="email" size="lg" className="form-group">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            required
            size="lg"
            autoFocus
            type="email"
            value={fields.email}
            onChange={handleFieldChange}
          />
          <Form.Control.Feedback type="invalid">
            {!fields.email || fields.email.length === 0
              ? "This is required"
              : "Invalid email"}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="password" size="lg" className="form-group">
          <Form.Label>Password</Form.Label>
          <Form.Control
            required
            size="lg"
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
          <Form.Control.Feedback type="invalid">
            This is required.
          </Form.Control.Feedback>
        </Form.Group>
        {errors && (
          <span className="invalid-feedback d-block pb-2">{errors}</span>
        )}
        <div className="d-flex justify-content-end pt-2 pb-3">
          <Link to="/login/reset" className="secondary">
            Forgot password?
          </Link>
        </div>

        <LoaderButton
          block
          type="submit"
          variant="primary"
          size="lg"
          isLoading={isLoading}
        >
          Log in to Taabl
        </LoaderButton>
        <div className="d-flex justify-content-center pt-3 font-secondary account">
          Don't have an account?
          <Link to="/taablsignup" className="secondary ps-1">
            Sign up
          </Link>
        </div>
      </Form>
    </FormImage>
  );
}
